export const rollbar = () => (__CLIENT__ ? window.Rollbar : global.rollbar);

const rollbarMethod = (method, ...args) => {
  if (__LOCAL_DEV__) {
    (console[method] || console.error)(...args); // eslint-disable-line no-console
  }
  const rb = rollbar();
  if (rb) {
    rb[method](...args);
  }
};

export const critical = rollbarMethod.bind(null, 'critical');
export const log = rollbarMethod.bind(null, 'log');
export const error = rollbarMethod.bind(null, 'error');
export const warn = rollbarMethod.bind(null, 'warn');
export const info = rollbarMethod.bind(null, 'info');
export const debug = rollbarMethod.bind(null, 'debug');
